import {h} from 'ui/Framework';

export default h('svg', {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '30',
  height: '32',
  viewBox: '-1 -1 32 34'
}, [
  h('path', {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: '#8091A5',
    d: 'M28.8 1H1.3C.6 1 0 1.6 0 2.3v27.4c0 .7.6 1.3 1.3 1.3h27.4c.8 0 1.3-.6 1.3-1.3V2.3c0-.7-.6-1.3-1.2-1.3zM18 24.1c0 .4-.1.8-.2 1.3-.1.4-.2.8-.5 1.2-.2.4-.5.7-1 .9-.4.2-.9.3-1.6.3-.8 0-1.5-.2-2-.7-.5-.5-.8-1-1-1.7l1.7-.5c.1.3.2.6.4.8.2.2.5.3.8.3.2 0 .5-.1.7-.1.2-.1.3-.2.4-.4.1-.2.2-.4.2-.7.1-.3.1-.5.1-.8v-7h2v7.1zm3.6-3.9c.1.2.2.3.4.5.2.1.4.2.7.3.2.1.5.2.8.2.3.2.7.2 1 .4.4.2.8.3 1 .5.3.2.5.5.8.8.2.3.2.8.2 1.3.4.8.2 1.3 0 1.7s-.5.8-.8 1c-.3.2-.8.5-1.3.7-.5.2-1 .2-1.4.2-.7 0-1.3-.2-2-.4s-1.2-.7-1.6-1.1l1.3-1.3c.2.3.6.7 1 .8.5.2.8.3 1.3.3.2 0 .5 0 .7-.1.2-.1.4-.1.6-.2.2-.2.3-.2.5-.5.1-.2.2-.5.2-.8 0-.2-.1-.5-.2-.8l-.5-.5c-.2-.1-.5-.2-.8-.3l-.9-.3c-.3-.2-.7-.2-1-.3-.3-.2-.6-.3-.8-.5-.2-.2-.4-.5-.6-.8-.2-.3-.2-.8-.2-1.3s.1-1 .3-1.4c.2-.4.5-.8.8-1 .3-.2.8-.5 1.3-.6.5-.2.9-.2 1.4-.2.5 0 1 .1 1.6.2.5.2 1 .4 1.4.8l-1.3 1.3c-.2-.2-.5-.5-.8-.7-.4-.2-.8-.2-1.1-.2-.2 0-.5 0-.7.1-.2.1-.4.2-.6.2-.2.1-.3.2-.4.4-.2.2-.2.4-.2.7-.2.6-.1.8-.1.9z'
  })
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-js.es6.js